var _path, _path2, _path3, _path4, _g, _g2, _g3, _path5, _path6, _path7, _path8, _path9, _g4, _path10, _g5, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g6, _g7, _g8, _rect, _rect2, _g9, _g10, _path19, _path20, _g11, _g12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragNDrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1008px",
    height: "612px",
    viewBox: "0 0 1008 612",
    enableBackground: "new 0 0 1008 612",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone_book") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "stickers",
    display: "none"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 374.0349,
    cy: 369.9724,
    r: 55.6209,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A6E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00599C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_1_)",
    d: "M709.295,281.664h30.182c5.168-0.073,9.417,4.057,9.49,9.226 c0.001,0.088,0.001,0.177,0,0.265v58.702c-0.039,5.226-4.266,9.452-9.49,9.491h-30.242c-5.225-0.039-9.451-4.266-9.49-9.491 v-58.714c-0.067-5.169,4.068-9.413,9.236-9.48C709.086,281.661,709.19,281.661,709.295,281.664z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 374.0344,
    cy: 435.4246,
    r: 49.76,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBD3CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBE50A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_2_)",
    d: "M709.295,197.167h30.229c5.242,0,9.491,4.249,9.491,9.491v58.689 c0,5.241-4.249,9.491-9.491,9.491h-30.229c-5.242,0-9.491-4.25-9.491-9.491v-58.689 C699.804,201.416,704.053,197.167,709.295,197.167z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 377.4744,
    cy: 504.3123,
    r: 51.7117,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A551"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00652E"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_3_)",
    d: "M709.295,113.268h30.229c5.242,0,9.491,4.249,9.491,9.49v58.689 c0,5.242-4.249,9.491-9.491,9.491h-30.229c-5.242,0-9.491-4.249-9.491-9.491v-58.689 C699.804,117.517,704.053,113.268,709.295,113.268z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 201.803,
    cy: 514.6541,
    r: 366.5341,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007AAA"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M385.557,47.155h265.634c38.25,0,69.962,29.883,69.962,66.412v332.619 c0,36.457-31.724,66.412-69.962,66.412H385.557c-38.537,0-69.962-29.943-69.962-66.412V113.554 C315.595,77.097,347.02,47.155,385.557,47.155z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "oppening"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M394.162,59.909h248.135c35.859,0,65.229,23.416,65.229,52.176v1.195 c-5.94-24.026-32.596-42.398-64.344-42.398H393.565c-32.022,0-58.701,18.385-64.63,42.398v-1.195 C328.935,83.325,358.291,59.909,394.162,59.909z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "handle",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FECB30",
    d: "M502.075,240.748c-4.605,16.343-4.914,33.599-0.896,50.096 c4.065,15.971,12.123,30.646,23.416,42.648c7.71,8.308,10.076,9.192,13.041,20.751l9.49,39.445 c3.264,13.041,3.861,18.085-10.674,11.271c-37.354-17.487-68.479-54.841-80.337-102.868c-12.156-48.327-2.08-96.343,23.129-129.847 c7.71-10.077,10.077-11.272,13.34,1.78l10.675,42.1C505.924,227.707,505.326,229.5,502.075,240.748z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FECB30",
    d: "M501.179,155.39l26.081-6.526c4.57-1.049,9.152,1.701,10.376,6.228l16.005,64.332 c1.056,4.571-1.697,9.157-6.228,10.375l-26.094,6.526c-4.529,1.179-9.157-1.538-10.335-6.067c-0.014-0.054-0.027-0.106-0.04-0.16 l-16.018-64.032C493.79,161.403,496.557,156.679,501.179,155.39z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FECB30",
    d: "M544.76,329.978l26.094-6.526c4.537-1.174,9.168,1.554,10.341,6.092 c0.012,0.045,0.023,0.09,0.034,0.136l16.006,64.033c1.146,4.655-1.611,9.38-6.229,10.674l-26.045,6.526 c-4.571,1.056-9.157-1.697-10.376-6.228l-16.017-64.332C537.517,335.795,540.248,331.218,544.76,329.978z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "shadow",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#231F20",
    d: "M359.475,163.376c13.915,0.165,25.329-10.982,25.494-24.897s-10.981-25.329-24.896-25.494 s-25.329,10.981-25.494,24.896c-0.001,0.1-0.002,0.198-0.002,0.298c-0.152,13.763,10.883,25.044,24.646,25.195 C359.306,163.375,359.391,163.376,359.475,163.376z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#231F20",
    d: "M359.475,234.281c13.833-0.907,24.313-12.856,23.405-26.689 c-0.824-12.569-10.836-22.582-23.405-23.406c-13.834,0.907-24.313,12.857-23.405,26.69 C336.894,223.445,346.906,233.457,359.475,234.281z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#231F20",
    d: "M359.475,305.379c13.916,0,25.197-11.281,25.197-25.197s-11.281-25.197-25.197-25.197 s-25.197,11.281-25.197,25.197S345.559,305.379,359.475,305.379z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#231F20",
    d: "M359.475,376.224c13.833-0.906,24.313-12.856,23.405-26.689 c-0.824-12.569-10.836-22.581-23.405-23.405c-13.834,0.907-24.313,12.856-23.405,26.689 C336.894,365.388,346.906,375.401,359.475,376.224z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#231F20",
    d: "M359.475,447.382c13.862,0.112,25.191-11.035,25.304-24.897 c0.112-13.863-11.035-25.191-24.897-25.304c-13.863-0.112-25.192,11.035-25.304,24.897c-0.001,0.036-0.001,0.071-0.001,0.106 c-0.146,13.771,10.899,25.051,24.67,25.196C359.323,447.382,359.399,447.382,359.475,447.382z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "wire",
    display: "none"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.8562,
    y1: 487.0925,
    x2: 30.8562,
    y2: 523.0336,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E7E8"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_5_)",
    d: "M281.504,117.14h72.341c12.443,0,22.531,9.491,22.531,21.349l0,0 c0,11.857-10.076,21.349-22.531,21.349h-72.341c-12.442-0.024-22.543-9.515-22.543-21.373l0,0 C258.961,126.607,269.062,117.14,281.504,117.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.8562,
    y1: 428.533,
    x2: 30.8562,
    y2: 464.5037,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E7E8"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_6_)",
    d: "M281.504,187.664h72.341c12.443,0,22.531,9.778,22.531,21.647l0,0 c0,11.559-10.076,21.349-22.531,21.349h-72.341c-12.442,0.035-22.543-9.778-22.543-21.337l0,0 C258.961,197.466,269.062,187.664,281.504,187.664z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.8562,
    y1: 366.533,
    x2: 30.8562,
    y2: 402.463,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E7E8"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_7_)",
    d: "M281.504,258.534h72.341c12.443,0,22.531,9.491,22.531,21.349l0,0 c0,11.857-10.076,21.349-22.531,21.349h-72.341c-12.442-0.013-22.543-9.491-22.543-21.349l0,0 C258.961,268.025,269.062,258.534,281.504,258.534z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.8562,
    y1: 307.9714,
    x2: 30.8562,
    y2: 343.9304,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E7E8"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_8_)",
    d: "M281.504,329.094h72.341c12.443,0,22.531,9.777,22.531,21.636l0,0 c0,11.559-10.076,21.348-22.531,21.348h-72.341c-12.442,0-22.543-9.777-22.543-21.348l0,0 C258.961,338.871,269.062,329.094,281.504,329.094z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.8611,
    y1: 249.4104,
    x2: 30.8611,
    y2: 285.351,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E7E8"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_9_)",
    d: "M281.504,399.94h72.341c12.443,0,22.531,9.49,22.531,21.348l0,0 c0,11.857-10.076,21.349-22.531,21.349h-72.341c-12.442,0-22.531-9.491-22.531-21.349l0,0 C258.961,409.43,269.062,399.94,281.504,399.94z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "user",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    opacity: 0.3,
    fill: "#0F1027",
    d: "M530,296.991c44.734,0,80.99-36.262,80.99-80.99s-36.256-80.99-80.99-80.99 s-80.99,36.262-80.99,80.99S485.266,296.991,530,296.991z M562.08,327.363h-64.16c-60.546,0-109.652,49.1-109.652,109.652 c0,12.11,9.82,21.938,21.93,21.938h239.616c12.11,0.018,21.918-9.789,21.918-21.938 C671.733,376.463,622.632,327.363,562.08,327.363z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FECB30",
    d: "M518,287.991c44.734,0,80.99-36.262,80.99-80.99s-36.256-80.99-80.99-80.99 s-80.99,36.262-80.99,80.99S473.266,287.991,518,287.991z M550.08,318.363h-64.16c-60.546,0-109.652,49.1-109.652,109.652 c0,12.11,9.82,21.938,21.93,21.938h239.616c12.11,0.018,21.918-9.789,21.918-21.938 C659.733,367.463,610.632,318.363,550.08,318.363z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "About",
    display: "none"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FECB30",
    d: "M518.125,87.5c84.568,0,153,68.432,153,153s-68.432,153-153,153s-153-68.432-153-153 S433.616,87.5,518.125,87.5z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "shadow2",
    display: "inline",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1751",
    d: "M527.125,132.244c-9.204,9.024-24.743,41.298-27.971,94.131h56.036 C551.988,173.542,536.448,141.268,527.125,132.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1751",
    d: "M639.962,226.375c-6.275-37.354-30.624-68.288-63.65-84.126c9.145,22.688,15.121,51.853,16.914,84.126 H639.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1751",
    d: "M639.962,264.625H593.19c-1.793,32.273-7.77,61.416-16.878,84.127 C609.363,332.878,633.627,302.038,639.962,264.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1751",
    d: "M555.095,264.625h-56.06c3.347,52.953,18.886,85.227,28.09,94.191 C536.448,349.851,551.988,317.578,555.095,264.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1751",
    d: "M477.997,142.225c-32.99,15.897-57.375,46.855-63.71,84.149h46.772 C462.937,194.101,468.913,164.936,477.997,142.225z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1751",
    d: "M477.997,348.775c-9.084-22.711-15.061-51.877-16.854-84.15h-46.856 C420.622,302.038,445.007,332.878,477.997,348.775z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1751",
    d: "M679,480.849H403.6c-16.897,0-30.6-13.701-30.6-30.6c0-16.896,13.703-30.6,30.6-30.6H679V480.849z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 518.1721,
    cy: 174.3093,
    r: 38.7311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007AAA"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_10_)",
    d: "M518.125,127.244c-9.204,9.024-24.743,41.298-27.971,94.131h56.036 C542.988,168.542,527.448,136.268,518.125,127.244z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 599.137,
    cy: 179.3118,
    r: 37.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007AAA"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_11_)",
    d: "M630.962,221.375c-6.275-37.354-30.624-68.288-63.65-84.126 c9.145,22.688,15.121,51.853,16.914,84.126H630.962z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 599.137,
    cy: 301.6882,
    r: 37.2973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007AAA"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_12_)",
    d: "M630.962,259.625H584.19c-1.793,32.273-7.77,61.416-16.878,84.127 C600.363,327.878,624.627,297.038,630.962,259.625z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 518.0647,
    cy: 306.7205,
    r: 38.7537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007AAA"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_13_)",
    d: "M546.095,259.625h-56.06c3.347,52.953,18.886,85.227,28.09,94.191 C527.448,344.851,542.988,312.578,546.095,259.625z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 437.1423,
    cy: 179.3,
    r: 37.3164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007AAA"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_14_)",
    d: "M468.997,137.225c-32.99,15.897-57.375,46.855-63.71,84.149h46.772 C453.937,189.101,459.913,159.936,468.997,137.225z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 437.1423,
    cy: 301.7,
    r: 37.3166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007AAA"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_15_)",
    d: "M468.997,343.775c-9.084-22.711-15.061-51.877-16.854-84.15h-46.856 C411.622,297.038,436.007,327.878,468.997,343.775z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FECB30",
    d: "M670,475.849H394.6c-16.897,0-30.6-13.701-30.6-30.6c0-16.896,13.703-30.6,30.6-30.6H670 V475.849z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FECB30",
    d: "M518.125,87.5c84.568,0,153,68.432,153,153s-68.432,153-153,153s-153-68.432-153-153 S433.616,87.5,518.125,87.5z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "bus",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    opacity: 0.3,
    fill: "#0F1027",
    d: "M530,135.76c86.751,0,144.586,22.721,144.586,51.637v30.982 c11.424,0,20.654,9.23,20.654,20.655v41.31c0,11.425-9.23,20.655-20.654,20.655v103.275c0,11.425-9.231,20.654-20.656,20.654 v20.656c0,11.424-9.23,20.654-20.654,20.654H612.62c-11.425,0-20.655-9.23-20.655-20.654v-20.656h-123.93v20.656 c0,11.424-9.23,20.654-20.655,20.654h-20.655c-11.425,0-20.655-9.23-20.655-20.654v-20.656c-11.405,0-20.655-9.229-20.655-20.654 V301c-11.405,0-20.655-9.23-20.655-20.655v-41.31c0-11.425,9.25-20.655,20.655-20.655v-30.982 C385.415,158.481,443.249,135.76,530,135.76z M426.725,301c0,11.426,9.23,20.654,20.655,20.654h72.293V218.38H447.38 c-11.425,0-20.655,9.23-20.655,20.655V301z M540.327,321.654h72.293c11.425,0,20.655-9.229,20.655-20.654v-61.965 c0-11.425-9.23-20.655-20.655-20.655h-72.293V321.654z M437.053,393.948c11.425,0,20.655-9.23,20.655-20.656 c0-11.424-9.23-20.654-20.655-20.654s-20.655,9.23-20.655,20.654C416.398,384.718,425.628,393.948,437.053,393.948z  M622.948,393.948c11.425,0,20.654-9.23,20.654-20.656c0-11.424-9.229-20.654-20.654-20.654c-11.426,0-20.655,9.23-20.655,20.654 C602.292,384.718,611.522,393.948,622.948,393.948z M581.638,177.07H478.363c-5.68,0-10.328,4.622-10.328,10.328 c0,5.706,4.647,10.328,10.328,10.328h103.275c5.679,0,10.327-4.622,10.327-10.328C591.965,181.692,587.317,177.07,581.638,177.07z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FECB30",
    d: "M519,126.76c86.751,0,144.586,22.721,144.586,51.637v30.982 c11.424,0,20.654,9.23,20.654,20.655v41.31c0,11.425-9.23,20.655-20.654,20.655v103.275c0,11.425-9.231,20.654-20.656,20.654 v20.656c0,11.424-9.23,20.654-20.654,20.654H601.62c-11.425,0-20.655-9.23-20.655-20.654v-20.656h-123.93v20.656 c0,11.424-9.23,20.654-20.655,20.654h-20.655c-11.425,0-20.655-9.23-20.655-20.654v-20.656c-11.405,0-20.655-9.229-20.655-20.654 V292c-11.405,0-20.655-9.23-20.655-20.655v-41.31c0-11.425,9.25-20.655,20.655-20.655v-30.982 C374.415,149.481,432.249,126.76,519,126.76z M415.725,292c0,11.426,9.23,20.654,20.655,20.654h72.293V209.38H436.38 c-11.425,0-20.655,9.23-20.655,20.655V292z M529.327,312.654h72.293c11.425,0,20.655-9.229,20.655-20.654v-61.965 c0-11.425-9.23-20.655-20.655-20.655h-72.293V312.654z M426.053,384.948c11.425,0,20.655-9.23,20.655-20.656 c0-11.424-9.23-20.654-20.655-20.654s-20.655,9.23-20.655,20.654C405.398,375.718,414.628,384.948,426.053,384.948z  M611.948,384.948c11.425,0,20.654-9.23,20.654-20.656c0-11.424-9.229-20.654-20.654-20.654c-11.426,0-20.655,9.23-20.655,20.654 C591.292,375.718,600.522,384.948,611.948,384.948z M570.638,168.07H467.363c-5.68,0-10.328,4.622-10.328,10.328 c0,5.706,4.647,10.328,10.328,10.328h103.275c5.679,0,10.327-4.622,10.327-10.328C580.965,172.692,576.317,168.07,570.638,168.07z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Dentist",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#0F1027",
    d: "M623.052,386.095c-5.736,10.2-11.366,20.213-19.78,28.859 c-13.133-40.15-16.736-68.424-53.727-96.829c-33.128-25.438-59.354-28.585-16.427,3.679c34.138,25.661,39.609,59.333,42.305,97.58 c0.768,10.902,8.614,53.949,22.741,55.177c4.709,0.409,9.834-9.345,16.003-19.129c42.906-68.02,75.421-167.257,81.083-245.301 c8.32-114.874-104.361-75.702-162.087-28.303c41.746,1.82,106.706-51.352,126.21,16.472c13.178,45.821-8.122,98.107-20.879,142 L623.052,386.095z M354.6,191.875c0.281-1.097,0.721-2.181,0.815-3.29c0.456-5.351,1.547-10.578,3.434-15.656 c4.521-12.167,13.028-21.386,24.822-28.159c8.993-5.163,18.731-8.446,29.276-9.57c11.308-1.204,22.29,0.207,32.953,3.802 c13.154,4.436,24.461,11.52,34.197,20.656c6.705,6.29,13.028,12.922,19.5,19.42c6.477,6.5,12.987,12.967,20.205,18.792 c5.037,4.064,10.386,7.714,16.502,10.326c7.04,3.007,14.471,4.103,22.187,3.949c10.646-0.213,20.991-2.23,31.326-4.305 c4.066-0.816,8.106-1.749,12.158-2.615c0.561-0.12,1.141-0.162,1.938-0.272c-0.339,0.677-0.555,1.172-0.825,1.641 c-6.505,11.205-16.491,18.285-29.951,21.222c-8.134,1.775-16.377,1.841-24.66,1.282c-8.556-0.577-16.872-2.14-24.941-4.842 c-8.739-2.926-16.938-6.849-24.817-11.336c-12.424-7.075-24.581-14.524-36.526-22.263c-5.189-3.362-10.428-6.662-16.075-9.357 c-4.78-2.28-9.772-3.975-15.174-4.578c-7.135-0.796-13.5,0.854-19.175,4.837c-4.056,2.849-7.133,6.481-9.719,10.479 c-5.105,7.892-8.165,16.397-9.11,25.552c-0.778,7.54-0.407,15.04,0.787,22.51c3.51,21.978,8.191,43.742,14.157,65.271 c6.388,23.053,13.958,45.782,22.254,68.309c5.46,14.821,11.109,29.584,16.72,44.358c0.493,1.301,1.181,2.589,2.043,3.714 c2.086,2.721,4.329,5.339,6.763,8.306c0.443-0.964,0.8-1.63,1.063-2.325c3.057-8.078,6.063-16.171,9.155-24.239 c4.016-10.477,8.359-20.834,13.92-30.724c5.062-8.999,11.069-17.396,18.742-24.732c9.371-8.962,20.478-15.472,33.119-19.834 c0.965-0.333,1.844-0.627,2.732,0.189c2.943,2.702,5.925,5.371,8.871,8.072c0.309,0.282,0.482,0.69,0.832,1.212 c-0.805,0.354-1.491,0.674-2.19,0.961c-10.225,4.191-19.618,9.554-27.823,16.592c-11.315,9.706-19.046,21.506-24.133,34.841 c-3.354,8.792-5.477,17.845-6.854,27.063c-1.088,7.282-1.808,14.591-2.049,21.934c-0.083,2.544,0.166,5.096,0.233,7.644 c0.108,4.122,0.347,8.249,0.22,12.366c-0.06,1.961-0.635,3.969-1.335,5.841c-1.408,3.767-4.313,6.344-8.331,7.825 c-3.669,1.351-7.444,2.064-11.437,1.557c-3.893-0.497-7.131-2.12-9.91-4.599c-2.688-2.396-4.807-5.198-6.422-8.269 c-2.413-4.588-4.619-9.266-6.936-13.896c-11.728-23.437-22.663-47.178-32.591-71.308c-11.611-28.219-21.794-56.861-30.197-86.029 c-5.542-19.235-10.369-38.621-14.142-58.218c-1.482-7.702-2.826-15.429-4.154-23.155c-0.36-2.093-0.377-4.233-0.655-6.339 c-0.148-1.122-0.519-2.217-0.79-3.324C354.6,196.732,354.6,194.302,354.6,191.875z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FECB30",
    d: "M614.052,377.095c-5.736,10.2-11.366,20.213-19.78,28.859c-13.133-40.15-16.736-68.424-53.727-96.829 c-33.128-25.438-59.354-28.585-16.427,3.679c34.138,25.661,39.609,59.333,42.305,97.58c0.768,10.902,8.614,53.949,22.741,55.177 c4.709,0.409,9.834-9.345,16.003-19.129c42.906-68.02,75.421-167.257,81.083-245.301c8.32-114.874-104.361-75.702-162.087-28.303 c41.746,1.82,106.706-51.352,126.21,16.472c13.178,45.821-8.122,98.107-20.879,142L614.052,377.095z M345.6,182.875 c0.281-1.097,0.721-2.181,0.815-3.29c0.456-5.351,1.547-10.578,3.434-15.656c4.521-12.167,13.028-21.386,24.822-28.159 c8.993-5.163,18.731-8.446,29.276-9.57c11.308-1.204,22.29,0.207,32.953,3.802c13.154,4.436,24.461,11.52,34.197,20.656 c6.705,6.29,13.028,12.922,19.5,19.42c6.477,6.5,12.987,12.967,20.205,18.792c5.037,4.064,10.386,7.714,16.502,10.326 c7.04,3.007,14.471,4.103,22.187,3.949c10.646-0.213,20.991-2.23,31.326-4.305c4.066-0.816,8.106-1.749,12.158-2.615 c0.561-0.12,1.141-0.162,1.938-0.272c-0.339,0.677-0.555,1.172-0.825,1.641c-6.505,11.205-16.491,18.285-29.951,21.222 c-8.134,1.775-16.377,1.841-24.66,1.282c-8.556-0.577-16.872-2.14-24.941-4.842c-8.739-2.926-16.938-6.849-24.817-11.336 c-12.424-7.075-24.581-14.524-36.526-22.263c-5.189-3.362-10.428-6.662-16.075-9.357c-4.78-2.28-9.772-3.975-15.174-4.578 c-7.135-0.796-13.5,0.854-19.175,4.837c-4.056,2.849-7.133,6.481-9.719,10.479c-5.105,7.892-8.165,16.397-9.11,25.552 c-0.778,7.54-0.407,15.04,0.787,22.51c3.51,21.978,8.191,43.742,14.157,65.271c6.388,23.053,13.958,45.782,22.254,68.309 c5.46,14.821,11.109,29.584,16.72,44.358c0.493,1.301,1.181,2.589,2.043,3.714c2.086,2.721,4.329,5.339,6.763,8.306 c0.443-0.964,0.8-1.63,1.063-2.325c3.057-8.078,6.063-16.171,9.155-24.239c4.016-10.477,8.359-20.834,13.92-30.724 c5.062-8.999,11.069-17.396,18.742-24.732c9.371-8.962,20.478-15.472,33.119-19.834c0.965-0.333,1.844-0.627,2.732,0.189 c2.943,2.702,5.925,5.371,8.871,8.072c0.309,0.282,0.482,0.69,0.832,1.212c-0.805,0.354-1.491,0.674-2.19,0.961 c-10.225,4.191-19.618,9.554-27.823,16.592c-11.315,9.706-19.046,21.506-24.133,34.841c-3.354,8.792-5.477,17.845-6.854,27.063 c-1.088,7.282-1.808,14.591-2.049,21.934c-0.083,2.544,0.166,5.096,0.233,7.644c0.108,4.122,0.347,8.249,0.22,12.366 c-0.06,1.961-0.635,3.969-1.335,5.841c-1.408,3.767-4.313,6.344-8.331,7.825c-3.669,1.351-7.444,2.064-11.437,1.557 c-3.893-0.497-7.131-2.12-9.91-4.599c-2.688-2.396-4.807-5.198-6.422-8.269c-2.413-4.588-4.619-9.266-6.936-13.896 c-11.728-23.437-22.663-47.178-32.591-71.308c-11.611-28.219-21.794-56.861-30.197-86.029 c-5.542-19.235-10.369-38.621-14.142-58.218c-1.482-7.702-2.826-15.429-4.154-23.155c-0.36-2.093-0.377-4.233-0.655-6.339 c-0.148-1.122-0.519-2.217-0.79-3.324C345.6,187.732,345.6,185.302,345.6,182.875z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "contactUs",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    opacity: 0.3,
    fill: "#0F1027",
    d: "M662.744,172.775c17.422,0,31.557,14.128,31.557,31.557 c0,9.927-4.668,19.262-12.623,25.245L538.622,336.868c-7.494,5.588-17.75,5.588-25.244,0L370.323,229.576 c-7.946-5.983-12.623-15.318-12.623-25.245c0-17.428,14.127-31.557,31.556-31.557H662.744z M500.755,353.697 c14.989,11.242,35.501,11.242,50.49,0l143.056-107.291V383.15c0,23.207-18.869,42.074-42.076,42.074H399.776 c-23.24,0-42.075-18.867-42.075-42.074V246.406L500.755,353.697z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FECB30",
    d: "M654.744,160.775c17.422,0,31.557,14.128,31.557,31.557 c0,9.927-4.668,19.262-12.623,25.245L530.622,324.868c-7.494,5.588-17.75,5.588-25.244,0L362.323,217.576 c-7.946-5.983-12.623-15.318-12.623-25.245c0-17.428,14.127-31.557,31.556-31.557H654.744z M492.755,341.697 c14.989,11.242,35.501,11.242,50.49,0l143.056-107.291V371.15c0,23.207-18.869,42.074-42.076,42.074H391.776 c-23.24,0-42.075-18.867-42.075-42.074V234.406L492.755,341.697z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 376.5,
    y: 264.5,
    opacity: 0.3,
    fill: "#0F1027",
    width: 229,
    height: 228
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.5002,
    y1: 360.4998,
    x2: 587.5002,
    y2: 360.4998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BDBDBD"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 358.5,
    y: 246.5,
    fill: "url(#SVGID_16_)",
    width: 229,
    height: 228
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    points: "587.5,468.5 587.5,474.5 581.5,474.5  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeDasharray: "4.465,10.716,10.716,4.465",
    x1: 577.035,
    y1: 474.5,
    x2: 548.906,
    y2: 474.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeDasharray: "10.716,4.465,4.465,10.716,10.716,4.465",
    x1: 546.673,
    y1: 474.5,
    x2: 366.733,
    y2: 474.5
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    points: "364.5,474.5 358.5,474.5 358.5,468.5  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeDasharray: "5.625,13.5,13.5,5.625",
    x1: 358.5,
    y1: 462.875,
    x2: 358.5,
    y2: 427.437
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeDasharray: "13.5,5.625,5.625,13.5,13.5,5.625",
    x1: 358.5,
    y1: 424.625,
    x2: 358.5,
    y2: 255.312
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    points: "358.5,252.5 358.5,246.5 364.5,246.5  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeDasharray: "4.465,10.716,10.716,4.465",
    x1: 368.965,
    y1: 246.5,
    x2: 397.095,
    y2: 246.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeDasharray: "10.716,4.465,4.465,10.716,10.716,4.465",
    x1: 399.327,
    y1: 246.5,
    x2: 579.268,
    y2: 246.5
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    points: "581.5,246.5 587.5,246.5 587.5,252.5  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeDasharray: "5.625,13.5,13.5,5.625",
    x1: 587.5,
    y1: 258.125,
    x2: 587.5,
    y2: 293.562
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeDasharray: "13.5,5.625,5.625,13.5,13.5,5.625",
    x1: 587.5,
    y1: 296.375,
    x2: 587.5,
    y2: 465.687
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 469.5,
    y1: 136.5,
    x2: 646.5,
    y2: 99.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FECB30",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeDasharray: "12,5,5,12,12,5",
    x1: 527.935,
    y1: 124.285,
    x2: 646.5,
    y2: 99.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FECB30",
    points: "563.003,154.785 540.027,121.757 547.849,82.29 469.5,136.5  "
  }))))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#0F1027",
    d: "M510.7,194.1c0,19.44-15.759,35.2-35.2,35.2c-19.44,0-35.2-15.759-35.2-35.2 c0-14.581,8.865-27.09,21.498-32.434c4.211-1.781,10.441-13.966,15.302-13.966c4.248,0,6.72,11.953,10.491,13.332 C501.076,165.963,510.7,178.907,510.7,194.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FECB30",
    stroke: "#000000",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M502.7,186.1c0,19.44-15.759,35.2-35.2,35.2 c-19.44,0-35.2-15.759-35.2-35.2c0-14.581,8.865-27.09,21.498-32.434c4.211-1.781,10.441-13.966,15.302-13.966 c4.248,0,6.72,11.953,10.491,13.332C493.076,157.963,502.7,170.907,502.7,186.1z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M416.337,367.413c1.872,1.152,4.608,2.112,7.489,2.112c4.272,0,6.769-2.256,6.769-5.521c0-3.024-1.728-4.752-6.097-6.433 c-5.28-1.872-8.544-4.608-8.544-9.168c0-5.041,4.176-8.785,10.465-8.785c3.312,0,5.712,0.768,7.152,1.584l-1.152,3.408 c-1.056-0.576-3.216-1.536-6.145-1.536c-4.417,0-6.097,2.641-6.097,4.849c0,3.024,1.968,4.513,6.433,6.24 c5.472,2.112,8.257,4.753,8.257,9.505c0,4.993-3.696,9.313-11.329,9.313c-3.12,0-6.529-0.912-8.257-2.064L416.337,367.413z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.785,361.653c0.096,5.712,3.745,8.064,7.969,8.064c3.024,0,4.849-0.528,6.433-1.2l0.72,3.024 c-1.488,0.672-4.033,1.44-7.729,1.44c-7.152,0-11.425-4.705-11.425-11.714c0-7.008,4.128-12.528,10.897-12.528 c7.584,0,9.601,6.672,9.601,10.944c0,0.864-0.096,1.536-0.144,1.969H442.785z M455.17,358.629 c0.048-2.688-1.104-6.865-5.856-6.865c-4.272,0-6.145,3.937-6.481,6.865H455.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.48,356.516c0-2.736-0.048-5.089-0.192-7.249h3.696l0.144,4.561h0.192c1.056-3.12,3.6-5.088,6.433-5.088 c0.48,0,0.816,0.048,1.2,0.144v3.984c-0.432-0.096-0.864-0.144-1.44-0.144c-2.976,0-5.088,2.256-5.665,5.424 c-0.096,0.576-0.192,1.248-0.192,1.969v12.385h-4.176V356.516z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.808,349.267l4.561,13.058c0.768,2.112,1.392,4.032,1.872,5.952h0.144c0.528-1.92,1.2-3.84,1.968-5.952l4.512-13.058 h4.417l-9.121,23.234h-4.032l-8.833-23.234H481.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.615,361.653c0.096,5.712,3.744,8.064,7.969,8.064c3.024,0,4.849-0.528,6.433-1.2l0.72,3.024 c-1.488,0.672-4.032,1.44-7.729,1.44c-7.152,0-11.425-4.705-11.425-11.714c0-7.008,4.128-12.528,10.896-12.528 c7.585,0,9.601,6.672,9.601,10.944c0,0.864-0.096,1.536-0.144,1.969H505.615z M518,358.629c0.048-2.688-1.104-6.865-5.856-6.865 c-4.272,0-6.145,3.937-6.48,6.865H518z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.311,356.516c0-2.736-0.048-5.089-0.191-7.249h3.696l0.144,4.561h0.192c1.056-3.12,3.601-5.088,6.433-5.088 c0.479,0,0.816,0.048,1.2,0.144v3.984c-0.433-0.096-0.864-0.144-1.44-0.144c-2.977,0-5.089,2.256-5.665,5.424 c-0.096,0.576-0.191,1.248-0.191,1.969v12.385h-4.177V356.516z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#800000018000000180000001",
    stroke: "#F9C606",
    d: "M516.828,158.578c2.544-0.384,5.568-0.672,8.881-0.672 c6,0,10.272,1.392,13.104,4.032c2.881,2.64,4.561,6.385,4.561,11.617c0,5.28-1.632,9.601-4.656,12.577 c-3.024,3.024-8.017,4.656-14.306,4.656c-2.976,0-5.472-0.144-7.584-0.384V158.578z M521.004,187.188 c1.057,0.192,2.593,0.24,4.225,0.24c8.929,0,13.777-4.992,13.777-13.729c0.048-7.633-4.272-12.481-13.105-12.481 c-2.16,0-3.792,0.192-4.896,0.432V187.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#800000018000000180000001",
    stroke: "#F9C606",
    d: "M548.651,174.515c0-2.736-0.048-5.088-0.191-7.249h3.696l0.144,4.56 h0.192c1.056-3.12,3.6-5.088,6.433-5.088c0.479,0,0.815,0.048,1.2,0.144v3.984c-0.433-0.096-0.864-0.144-1.44-0.144 c-2.977,0-5.089,2.256-5.665,5.425c-0.096,0.576-0.191,1.248-0.191,1.968v12.385h-4.177V174.515z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#800000018000000180000001",
    stroke: "#F9C606",
    d: "M585.373,178.692c0,8.593-5.953,12.337-11.569,12.337 c-6.289,0-11.137-4.608-11.137-11.953c0-7.777,5.088-12.337,11.521-12.337C580.861,166.739,585.373,171.587,585.373,178.692z  M566.94,178.932c0,5.088,2.928,8.929,7.057,8.929c4.032,0,7.057-3.792,7.057-9.025c0-3.937-1.969-8.929-6.961-8.929 S566.94,174.515,566.94,178.932z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#800000018000000180000001",
    stroke: "#F9C606",
    d: "M590.698,174.851c0-2.976-0.096-5.376-0.191-7.584h3.792l0.192,3.984 h0.096c1.729-2.833,4.465-4.513,8.257-4.513c5.616,0,9.841,4.752,9.841,11.809c0,8.353-5.089,12.481-10.561,12.481 c-3.072,0-5.761-1.344-7.153-3.648h-0.096v12.625h-4.177V174.851z M594.875,181.044c0,0.624,0.096,1.2,0.192,1.729 c0.768,2.928,3.312,4.944,6.336,4.944c4.465,0,7.057-3.648,7.057-8.977c0-4.656-2.448-8.641-6.912-8.641 c-2.881,0-5.568,2.064-6.385,5.232c-0.145,0.528-0.288,1.152-0.288,1.728V181.044z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragNDrop);
export default __webpack_public_path__ + "static/media/dragNDrop.a30310ca85e778c78b3afcb26d651f45.svg";
export { ForwardRef as ReactComponent };